<template>
  <b-modal
    id="modal-filters"
    ref="modal-filters"
    :visible="visible"
    title="Filters"
    @ok="$emit('ok')"
    @hidden="$emit('update:visible', false)"
    size="md"
    ok-title="Apply Filters"
    cancel-title="Cancel"
  >
    <b-form>
      <b-form-group v-if="canViewTeam" label="View Mode" label-for="view-mode-filter">
        <div class="d-flex gap-2">
          <b-button
            v-for="option in viewModeOptions"
            :key="option.value"
            :variant="viewModeTemp === option.value ? 'primary' : 'outline-primary'"
            size="sm"
            class="flex-fill"
            @click="$emit('update:viewModeTemp', option.value)"
          >
            <feather-icon :icon="option.icon" size="16" class="mr-1" />
            {{ option.text }}
          </b-button>
        </div>
      </b-form-group>

      <b-alert variant="info" show class="mb-3">
        <small>Apply filters to refine leaves, regularization cases, and attendance data.</small>
      </b-alert>

      <b-form-row>
        <b-col cols="6">
          <b-form-group label="From Date" label-for="filter-from-date">
            <b-form-input
              id="filter-from-date"
              :value="fromDateFilterTemp"
              type="date"
              size="sm"
              @input="$emit('update:fromDateFilterTemp', $event)"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="To Date" label-for="filter-to-date">
            <b-form-input
              id="filter-to-date"
              :value="toDateFilterTemp"
              type="date"
              size="sm"
              @input="$emit('update:toDateFilterTemp', $event)"
            />
          </b-form-group>
        </b-col>
      </b-form-row>

      <template v-if="(viewModeTemp === 'team' || viewModeTemp === 'org') && canApplyOnBehalfAll">
        <b-form-group label="Account Manager" label-for="account-manager-filter">
          <b-form-select
            id="account-manager-filter"
            :value="selectedAccountManagerTemp"
            :options="accountManagerOptions"
            size="sm"
            placeholder="Select Account Manager"
            @change="$emit('update:selectedAccountManagerTemp', $event)"
          >
            <template #first>
              <option :value="null">All Account Managers</option>
            </template>
          </b-form-select>
        </b-form-group>

        <b-form-group
          v-if="selectedAccountManagerTemp"
          label="Employee"
          label-for="employee-filter"
        >
          <b-form-select
            id="employee-filter"
            :value="selectedTeamWiseEmployeeTemp"
            :options="teamWiseEmployeeOptions"
            size="sm"
            placeholder="Select Employee"
            @change="$emit('update:selectedTeamWiseEmployeeTemp', $event)"
          >
            <template #first>
              <option :value="null">All Employees</option>
            </template>
          </b-form-select>
        </b-form-group>
      </template>

      <template v-if="viewModeTemp === 'team' && isAccountManager && !isAdmin && !isMaster">
        <b-form-group label="Team Member" label-for="team-member-filter">
          <b-form-select
            id="team-member-filter"
            :value="selectedTeamMemberTemp"
            :options="teamMemberOptions"
            size="sm"
            placeholder="Select a team member (leave empty for all)"
            @change="$emit('update:selectedTeamMemberTemp', $event)"
          >
          </b-form-select>
          <small class="text-muted d-block mt-1">Leave empty to view all team members</small>
        </b-form-group>
      </template>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal, BForm, BFormGroup, BFormRow, BCol, BAlert, BFormInput, BFormSelect, BButton,
} from 'bootstrap-vue'

export default {
  name: 'FiltersModal',
  components: {
    BModal, BForm, BFormGroup, BFormRow, BCol, BAlert, BFormInput, BFormSelect, BButton,
  },
  props: {
    visible: { type: Boolean, default: false },
    canViewTeam: { type: Boolean, default: false },
    viewModeOptions: { type: Array, default: () => [] },
    viewModeTemp: { type: String, default: 'my' },
    fromDateFilterTemp: { type: String, default: null },
    toDateFilterTemp: { type: String, default: null },
    canApplyOnBehalfAll: { type: Boolean, default: false },
    selectedAccountManagerTemp: { type: String, default: null },
    accountManagerOptions: { type: Array, default: () => [] },
    selectedTeamWiseEmployeeTemp: { type: String, default: null },
    teamWiseEmployeeOptions: { type: Array, default: () => [] },
    isAccountManager: { type: Boolean, default: false },
    isAdmin: { type: Boolean, default: false },
    isMaster: { type: Boolean, default: false },
    selectedTeamMemberTemp: { type: String, default: null },
    teamMemberOptions: { type: Array, default: () => [] },
  },
}
</script>
